import React, { useState, useEffect } from "react";
import styled from "styled-components";

import microApi from "../helpers/microApi";
import { prettyPercentChange, getWhens } from "../helpers/utils";

const HeadlineNumber = styled.span`
  font-size: 1.8rem;
  font-weight: bold;
`;

const HeadlineDescription = styled.span`
  font-size: 0.9rem;
  white-space: nowrap;
`;

const HeadlineItem = ({ number, description }) => {
  return (
    <div>
      <HeadlineNumber>{number + " "}</HeadlineNumber>
      <HeadlineDescription>
        {description}
      </HeadlineDescription>
    </div>
  );
};

const Grid = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: baseline;
  flex-flow: row wrap;

  & > * {
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 2rem solid transparent;
  }
`;

const Headline = ({ filters, timeframe, latestDay, nation }) => {
  const [data, setData] = useState();

  useEffect(() => {
    let cancel = false;
    const getData = async () => {
      const { currWhen, prevWhen, yearAgoWhen } = getWhens(
        timeframe,
        latestDay
      );

      const res = await Promise.all(
        [currWhen, prevWhen, yearAgoWhen].map((when) =>
          microApi.post(
            `${nation}/totals${
              nation === "us" ? "?soc_version=soc_emsi_2019" : ""
            }`,
            {
              filter: { when, ...filters },
            }
          )
        )
      );

      if (cancel) return;
      setData({
        periods: res.map((r) => r.data.data.totals),
        timeframe,
      });
    };
    getData();
    return () => (cancel = true);
  }, [filters, timeframe, latestDay, nation]);

  return data ? (
    <Grid>
      <HeadlineItem
        number={data.periods[0].unique_postings.toLocaleString()}
        description="postings"
      />

      <HeadlineItem
        number={prettyPercentChange(
          data.periods[1].unique_postings,
          data.periods[0].unique_postings
        )}
        description={`${data.timeframe} over ${data.timeframe}`}
      />
      <HeadlineItem
        number={prettyPercentChange(
          data.periods[2].unique_postings,
          data.periods[0].unique_postings
        )}
        description="from last year"
      />
    </Grid>
  ) : null;
};

export default Headline;
